import { render, staticRenderFns } from "./DataTableExample.vue?vue&type=template&id=2bf3c7d7&"
import script from "./DataTableExample.vue?vue&type=script&lang=js&"
export * from "./DataTableExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports